import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Fontes self-hosted. Primeiro import de propósito: o CSS de @font-face
// precisa estar no topo da cascata.
import '@anery/design-system/fontes';

// Tailwind (layout) e a folha da marca (identidade do piloto) — ADR-0005.
// Depois das fontes e antes do App: utilitário precisa vencer componente,
// e nenhum dos dois pode vencer @font-face.
import './tema/tailwind.css';
import './tema/anery-marca.css';
import './tema/anery-v2.css';

import { App } from './App';

// Não há modo mock AQUI, e é decisão de arquitetura.
//
// Quem decide se serve dado real ou sintético é a API — `ANERY_MODO=mock`
// na subida dela. O front sempre fala com a API, sempre pelo mesmo caminho.
//
// Antes existia um `VITE_MOCK_API` que ligava o MSW no navegador. O
// problema não era o mock: era haver DUAS fontes de verdade sobre o que a
// API devolve. Foi exatamente assim que o front passou a descrever uma API
// que não existia — com `protocolo`, `operadora` e envelope de paginação —
// e ninguém percebeu, porque os testes rodavam contra o próprio mock.
//
// O MSW continua vivo em `src/mocks/`, usado SÓ pelos testes. Lá ele é
// test double na fronteira HTTP, roda em processo e não é ambiente.
//
// Consequência prática: `iniciar` deixou de ser async — o único `await` que
// existia era o import dinâmico do worker.
function iniciar(): void {
  const raiz = document.getElementById('raiz');
  if (raiz === null) throw new Error('Elemento #raiz não encontrado no index.html.');

  createRoot(raiz).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

iniciar();
